// extracted by mini-css-extract-plugin
export var active = "_ec-7";
export var container = "_ec-0";
export var evenWidth = "_ec-4";
export var large = "_ec-5";
export var outlet = "_ec-8";
export var slide = "_ec-2";
export var small = "_ec-6";
export var tab = "_ec-3";
export var tabs = "_ec-1";